import { LatLng } from "./lat-lng";
export class Map {
    constructor(domObject) {
        this._boundsDataKey = "bounds";
        this._mapInitializedEvent = "map-initialized";
        this.markers = {};
        this.nextMarkerId = 1;
        this.infoWindowConents = {};
        this.initialized = false;
        this.domObject = domObject;
        GoogleJavascript.initialize(() => this.initializeMap());
    }
    parseBounds(boundsString) {
        if (boundsString === undefined) {
            return undefined;
        }
        const bounds = new google.maps.LatLngBounds();
        const boundsData = boundsString.split(",");
        for (let i = 0; i < boundsData.length; i += 2) {
            bounds.extend(new google.maps.LatLng(parseFloat(boundsData[i]), parseFloat(boundsData[i + 1])));
        }
        return bounds;
    }
    get bounds() {
        return;
    }
    initializeMap() {
        this.infoWindow = new google.maps.InfoWindow();
        this.map = new google.maps.Map(this.domObject, {
            center: { lat: -34.397, lng: 150.644 },
            zoom: 15,
        });
        const bounds = this.parseBounds(this.domObject.dataset[this._boundsDataKey]);
        if (bounds !== undefined) {
            this.map.fitBounds(bounds);
        }
        this.domObject.dataset["map"] = this;
        this.domObject.dispatchEvent(new Event(this._mapInitializedEvent));
        this.initialized = true;
    }
    onInitialized(callback) {
        if (this.initialized) {
            callback();
        }
        else {
            this.domObject.addEventListener(this._mapInitializedEvent, callback);
        }
    }
    onClick(callback) {
        const onClick = () => {
            this.map.addListener("click", (event) => {
                callback(new LatLng(event.latLng.lat(), event.latLng.lng()));
            });
        };
        if (this.map) {
            onClick();
        }
        else {
            this.domObject.addEventListener(this._mapInitializedEvent, onClick);
        }
    }
    addMarker(coordinates, title, content) {
        const id = this.nextMarkerId++;
        const marker = (this.markers[id] = new google.maps.Marker({
            position: coordinates.toGoogleMapsLatLng(),
            map: this.map,
            title,
            icon: "https://i.ibb.co/LtFFhvp/faviconex1.png",
        }));
        this.infoWindowConents[id] = content;
        marker.addListener("click", () => {
            if (!this.infoWindowConents[id]) {
                return;
            }
            this.infoWindow.close();
            this.infoWindow.setContent(this.infoWindowConents[id]);
            this.infoWindow.open(this.map, marker);
        });
        this.centerToCoordinates(coordinates);
        return id;
    }
    fitToBounds(bounds) {
        if (bounds === undefined) {
            return;
        }
        this.map.fitBounds(bounds.toGoogleMapsBounds());
    }
    centerToCoordinates(coordinates) {
        this.map.setCenter(coordinates.toGoogleMapsLatLng());
    }
    hideMarker(idMarker) {
        this.infoWindow.close();
        this.getMarker(idMarker).setMap(null);
    }
    showMarker(idMarker) {
        this.getMarker(idMarker).setMap(this.map);
    }
    updateContent(idMarker, content) {
        this.infoWindowConents[idMarker] = content;
    }
    getMarker(idMarker) {
        const marker = this.markers[idMarker];
        if (marker === undefined) {
            throw new Error(`Marca ${idMarker} no existe`);
        }
        return marker;
    }
    removeMarker(markerId) {
        this.getMarker(markerId).setMap(null);
        delete this.markers[markerId];
    }
}
class GoogleJavascript {
    static initialize(callback) {
        if (GoogleJavascript.googleMapsInitialized) {
            callback();
            return;
        }
        GoogleJavascript.callbacks.push(callback);
        window["initMap"] = () => {
            for (const callback of GoogleJavascript.callbacks) {
                callback();
            }
        };
        const url = `https://maps.googleapis.com/maps/api/js?key=${GoogleJavascript.apiKey}&callback=initMap`;
        $("<script>").attr("src", url).appendTo($("body"));
        GoogleJavascript.googleMapsInitialized = true;
    }
}
GoogleJavascript.apiKey = "AIzaSyD666atbNyBX9zPuyo9dVISQ6XTzi4urlo";
GoogleJavascript.googleMapsInitialized = false;
GoogleJavascript.callbacks = [];
